module.exports = __webpack_public_path__ + "static/line-receipt-488393721f39fd95da172eb2147afe53.jpg";